// noinspection JSUnfilteredForInLoop

import Vue from 'vue';
import Vuex from 'vuex';
import L from "leaflet";
import * as esri from "esri-leaflet";
const axios = require("axios");

Vue.use(Vuex);

// noinspection JSCheckFunctionSignatures
export default new Vuex.Store({
    namespaced: true,
    modules: {},
    state: {
        map: undefined,
        mapLayers: {},
        additionalActivityMapLayers: {},
        additionalActivityLegendLayers: {},
        mpaDetails: {
            MCZ: {},
            SAC: {},
            SPA: {},
            NCMPA: {},
        },
        byelawDetails: {},
        stats: {
            areaOverviewData: {},
            mpaOverviewData: {},
            mpasAndByelawsData: {},
            habitatsData: {},
            demersalFishingData: {},
            conditionData: {}
        }
    },
    mutations: {
        saveMpa: function (state, data) {  // data = [mpa_type, mpa_code, mpa details from server]
            state.mpaDetails[data[0]][data[1]] = data[2];
        },
        saveByelaw: function (state, data) {  // data = [byelaw_code, byelaw details from server]
            state.byelawDetails[data[0]] = data[1];
        },
        addMap: function (state, mapObject) {
            state.map = mapObject;
        },
        addMapLayer: function (state, data) {  // data = [layer_from_server, leaflet_layer]
            state.mapLayers[data[0]["layer_name"]] = data[0];
            state.mapLayers[data[0]["layer_name"]]["layer"] = data[1];
            state.mapLayers[data[0]["layer_name"]]["layer_enabled"] = data[0]["start_enabled"];
        },
        addAdditionalActivityMapLayer: function (state, data) {  // data = [layer_from_server, leaflet_layer]
            // this is a mess, it's not reactive, but adding a leaflet layer, e.g. with:
            // Vue.set(state.additionalActivityMapLayers, data[0]["layer_name"], {})
            // causes cyclic issues
            state.additionalActivityMapLayers[data[0]["layer_name"]] = data[0];
            state.additionalActivityMapLayers[data[0]["layer_name"]]["layer"] = data[1];
            state.additionalActivityMapLayers[data[0]["layer_name"]]["layer_enabled"] = data[0]["start_enabled"];

            // need the reactivity for the legend, this doesn't have the leaflet layer included
            Vue.set(state.additionalActivityLegendLayers, data[0]["layer_name"], {})
            state.additionalActivityLegendLayers[data[0]["layer_name"]] = {
                layer_name: data[0].layer_name,
                mparc_legend: data[0].mparc_legend,
                allow_control: data[0].allow_control,
                layer_enabled: data[0].layer_enabled,
                layer_name_display: data[0].layer_name_display,
                leaflet_legend_styles: data[0].leaflet_legend_styles,
                legend_additional_text: data[0].legend_additional_text,
                legend_below_title: data[0].legend_below_title,
                leaflet_styles: data[0].leaflet_styles,
                legend_graphic: data[0].legend_graphic
            };
        },
        toggleSingleMapLayer: function (state, layerData) {  // layerData = [mapLayers reference, new state]
            state.mapLayers[layerData[0]].layer_enabled = layerData[1];
            if (layerData[1]) {
                state.mapLayers[layerData[0]].layer.addTo(state.map);
            } else {
                state.map.removeLayer(state.mapLayers[layerData[0]].layer);
            }
        },
        toggleActivitiesMapLayer: function (state, layerData) {  // layerData = [layer name, new state]
            // console.log("state.additionalActivityMapLayers", state.additionalActivityMapLayers)
            // console.log("layerData", layerData)
            state.additionalActivityMapLayers[layerData[0]].layer_enabled = layerData[1];
            if (layerData[1]) {
                state.additionalActivityMapLayers[layerData[0]].layer.addTo(state.map);
            } else {
                state.map.removeLayer(state.additionalActivityMapLayers[layerData[0]].layer);
            }
        }
    },
    actions: {
        getBoundaryDetails: function (context, boundaryDetails) {
            const boundaryType = boundaryDetails[0];
            const boundaryCode = boundaryDetails[1];

            return new Promise((resolve, reject) => {
                // Does data exist in cache?
                if (boundaryType === "byelaw") {
                    if (context.state.byelawDetails[boundaryCode]) {
                        resolve(context.state.byelawDetails[boundaryCode])
                        return
                    }
                } else {
                    if (context.state.mpaDetails[boundaryType][boundaryCode]) {
                        resolve(context.state.mpaDetails[boundaryType][boundaryCode]);
                        return
                    }
                }

                if (boundaryType === "byelaw") {
                    // noinspection JSUnresolvedVariable
                    axios.get(mparc.urls.queryByelaw, {
                            params: {
                                byelaw_code: boundaryCode
                            }
                        })
                        .then((returned_data) => {
                            // console.log(returned_data);
                            context.commit("saveByelaw", [boundaryCode, returned_data.data])

                            resolve(context.state.byelawDetails[boundaryCode]);

                        })
                        .catch((error) => {
                            reject(error.response ? error.response.data : "Error getting data")
                        })

                } else {
                    // noinspection JSUnresolvedVariable
                    axios.get(mparc.urls.queryMPA, {
                            params: {
                                mpa_type: boundaryType,
                                mpa_code: boundaryCode
                            }
                        })
                        .then((returned_data) => {
                            // console.log(returned_data);
                            context.commit("saveMpa", [boundaryType, boundaryCode, returned_data.data])

                            resolve(context.state.mpaDetails[boundaryType][boundaryCode]);

                        })
                        .catch((error) => {
                            reject(error.response ? error.response.data : "Error getting data")
                        })
                }
            })
        },
        addMapCreateLayers: function (context, mapObject) {
            context.commit("addMap", mapObject);

            context.dispatch("createMapLayers", mparc.mapLayers)
                .then(() => {
                    context.getters.activeLayers.forEach(layer => {
                        layer.addTo(context.state.map);
                    })
                    // console.log("STORE1", context.state.additionalActivityMapLayers)
                });
        },
        createMapLayers: function (context, mapLayers) {
            return new Promise((resolve) => {
                // console.log("In create map layers", mapLayers)
                for (const layer in mapLayers) {
                    // todo: this is a mess and needs to be refactored out into its own methods

                    // console.log(layer, mapLayers[layer].geoserver_layers_ref, mparc.versionMetadata[mapLayers[layer].geoserver_layers_version_ref])
                    if (!mapLayers[layer].is_group) {
                        const wmsOptions = {
                            layers: mapLayers[layer].geoserver_layers_ref,
                            format: 'image/png', transparent: true, tiled: true,
                            zIndex: mapLayers[layer].leaflet_z_index
                        }

                        // Add version code for Cloudflare cache busting
                        if (mparc.versionMetadata[mapLayers[layer].geoserver_layers_version_ref]) {
                            wmsOptions["rcvc"] = mparc.versionMetadata[mapLayers[layer].geoserver_layers_version_ref]
                        }

                        const leafletLayer = L.tileLayer.wms(mparc.wmsUrl, wmsOptions)

                        context.commit("addMapLayer", [mapLayers[layer], leafletLayer])

                    } else {
                        // these are all groups
                        if (!mapLayers[layer].is_additional_activity_group) {
                            for (const sublayer in mapLayers[layer].layers) {
                                const wmsOptions = {
                                    layers: mapLayers[layer]["layers"][sublayer].geoserver_layers_ref,
                                    format: 'image/png', transparent: true, tiled: true,
                                    zIndex: mapLayers[layer].leaflet_z_index
                                }

                                if (mparc.versionMetadata[mapLayers[layer]["layers"][sublayer].geoserver_layers_version_ref]) {
                                    wmsOptions["rcvc"] = mparc.versionMetadata[mapLayers[layer]["layers"][sublayer].geoserver_layers_version_ref]
                                }

                                const leafletLayer = L.tileLayer.wms(mparc.wmsUrl, wmsOptions)

                                context.commit("addMapLayer", [mapLayers[layer]["layers"][sublayer], leafletLayer])
                            }
                        }

                        // this section is for the wildlife trust additional activity layers
                        if (mapLayers[layer].is_additional_activity_group) {
                            for (const sublayer in mapLayers[layer].layers) {
                                let leafletLayer, legendStyle = undefined;

                                if (mapLayers[layer]["layers"][sublayer].arcgis_online_url) {
                                    // ArcGIS online layer
                                    const styleObject = mapLayers[layer]["layers"][sublayer].additional_activity_json;
                                    // console.log("style", styleObject)

                                    if (styleObject) {
                                        // create a new legend entry. We'll put all info here and do the assembly in the vue component
                                        legendStyle = {
                                            legendTitle: mapLayers[layer]["layers"][sublayer].layer_name_display,
                                            legendItems: []
                                        }

                                        for (const rawLegend in styleObject.feature_map) {
                                            legendStyle.legendItems.push({
                                                    "category_name": rawLegend,
                                                    "style": styleObject.feature_map[rawLegend].legend
                                                }
                                            );
                                        }
                                    }

                                    leafletLayer = esri.featureLayer({
                                        url: mapLayers[layer]["layers"][sublayer].arcgis_online_url,
                                        style: function (feature) {
                                            if (styleObject) {
                                                // console.log("ft", feature)
                                                // console.log("so", styleObject)
                                                for (const featureToCompare in styleObject.feature_map) {
                                                    // do the match caseless, as some variation in data
                                                    if (feature.properties[styleObject.parameter_name].toLowerCase() === featureToCompare.toLowerCase()) {
                                                        return styleObject.feature_map[featureToCompare].style;
                                                    }
                                                }

                                            } else if (mapLayers[layer]["layers"][sublayer].leaflet_styles) {
                                                // turn the db style into an object, would be better as more json?
                                                const styleItems = mapLayers[layer]["layers"][sublayer].leaflet_styles.split(",")
                                                const leafletStyle = {}
                                                for (const st in styleItems) {
                                                    leafletStyle[styleItems[st].split(":")[0].trim()] = styleItems[st].split(":")[1].trim()
                                                }

                                                return leafletStyle;
                                            } else {
                                                return {color: "#70ca49", weight: 1};  // sensible default?
                                            }
                                        }
                                    })

                                } else {
                                    // standard WMS layer
                                    const wmsOptions = {
                                        layers: mapLayers[layer]["layers"][sublayer].geoserver_layers_ref,
                                        format: 'image/png', transparent: true, tiled: true,
                                        zIndex: mapLayers[layer].leaflet_z_index
                                    }

                                    if (mparc.versionMetadata[mapLayers[layer]["layers"][sublayer].geoserver_layers_version_ref]) {
                                        wmsOptions["rcvc"] = mparc.versionMetadata[mapLayers[layer]["layers"][sublayer].geoserver_layers_version_ref]
                                    }

                                    leafletLayer = L.tileLayer.wms(mparc.wmsUrl, wmsOptions)
                                }

                                mapLayers[layer]["layers"][sublayer]["mparc_legend"] = legendStyle;

                                context.commit("addAdditionalActivityMapLayer", [mapLayers[layer]["layers"][sublayer], leafletLayer])
                            }
                        }
                    }
                }

                resolve();
            });
        },
        updateDropdownGroupLayers: function (context, layerUpdates) {  // layerUpdates = [layer to enable, [layers to disable]]
            if (layerUpdates[0]) {
                context.commit("toggleSingleMapLayer", [layerUpdates[0], true])
            }

            layerUpdates[1].forEach(function (layer) {
                context.commit("toggleSingleMapLayer", [layer, false])
            })
        },
        loadStats: function (context, statsData) {
            context.state.stats.areaOverviewData = statsData.overview.authorities;
            context.state.stats.mpaOverviewData = statsData.overview.overview_area_mpas;
            context.state.stats.mpasAndByelawsData = statsData.mpas_and_byelaws;
            context.state.stats.habitatsData = statsData.habitats;
            context.state.stats.demersalFishingData = statsData.demersal_fishing;
            context.state.stats.conditionData = statsData.condition_data;
        }
    },
    getters: {
        activeLayers: function (state) {
            const layers = [];

            for (const layer in state.mapLayers) {
                if (state.mapLayers[layer].layer_enabled) {
                    layers.push(state.mapLayers[layer].layer);
                }
            }

            return layers;
        },
        additionalActivityLayers: function (state) {
            return state.additionalActivityMapLayers
            // const layerList = []
            // for (const layer in state.additionalActivityMapLayers) {
            //     layerList.push({layer: state.additionalActivityMapLayers[layer]})
            // }
            // console.log("ll", layerList)
            // return layerList
        }
    }
});
